import {Injectable} from '@angular/core';

import {AuthenticationService} from './index';
import {LoginHelper} from '../helpers';
import {BehaviorSubject, Subject, tap} from "rxjs";
import {Load} from "../_decorators/loading.decorator";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {IndexConfigService} from "./index.config.service";

@Injectable()
export class ConMonProfileService {
  constructor(public http: HttpClient,
              public config: IndexConfigService) {
  }

  public profileChanged = new BehaviorSubject<any>(null);
  public url(method: string, id: number = undefined, submethod: string = undefined) {
    let url = this.config.api + '/api/' + method;
    if (id) url += '/' + id;
    if (submethod) url += '/' + submethod;
    return url;
  }

  getConMonProfiles() {
    return this.http.get<any>(this.url('conMonProfiles'));
  }

  getConMonProfile(id) {
    return this.http.get<any>(this.url(`conMonProfiles/${id}`));
  }

  deleteConMonProfile(conMonProfileId: number) {
    return this.http.delete<any>(this.url('conMonProfile/' + conMonProfileId)).pipe(tap(_ => { this.profileChanged.next(null) }));
  }

  saveConMonProfile(conMonProfile: any) {
    return this.http.post<any>(this.url('conMonProfile'), conMonProfile).pipe(tap(_ => { this.profileChanged.next(null) }));
  }

  @Load()
  downloadSsp(conMonProfileId): Observable<any> {
    return this.http
      .get(this.config.api + '/api/conMonProfile/download/' + conMonProfileId, {responseType: 'arraybuffer', headers: {}});
  }

  @Load()
  postZipFile(entity: File, submitterId: string) {

    let formData = new FormData();

    formData.append(entity.name, entity, entity.name);

    return this.http
      .post<any>(this.config.api + '/api/attachments/conMonFile?submitterId=' + submitterId, formData)
      ;
  }
}
